import { Feature, Polygon, MultiPolygon } from "@turf/helpers"

export interface SpatialProcessingResult {
  features: Feature[]
  metadata: {
    featureCount: number
    totalArea?: number
    boundingBox?: [number, number, number, number] // [minLng, minLat, maxLng, maxLat]
    coordinateSystem?: string
  }
}

export interface SpatialValidationError {
  code: string
  message: string
  userMessage?: string // User-friendly version of the message
  details?: any
  recoverable?: boolean // Whether the user can potentially fix this error
  suggestions?: string[] // Suggestions for fixing the error
}

export interface SpatialFileInfo {
  name: string
  size: number
  type: "kml" | "shapefile"
  extension: string
}

export type SupportedGeometry = Polygon | MultiPolygon

export interface ProcessedBoundary {
  geometry: SupportedGeometry
  properties: Record<string, any>
  id: string
}

export const SPATIAL_ERROR_CODES = {
  INVALID_FILE_TYPE: "INVALID_FILE_TYPE",
  FILE_TOO_LARGE: "FILE_TOO_LARGE",
  MISSING_SHAPEFILE_COMPONENTS: "MISSING_SHAPEFILE_COMPONENTS",
  INVALID_COORDINATE_SYSTEM: "INVALID_COORDINATE_SYSTEM",
  NO_VALID_FEATURES: "NO_VALID_FEATURES",
  PROCESSING_FAILED: "PROCESSING_FAILED",
} as const

export const SUPPORTED_EXTENSIONS = [".kml", ".zip"] as const
export const MANDATORY_SHAPEFILE_EXTENSIONS = [
  "shp",
  "shx",
  "dbf",
  "prj",
] as const
export const ALLOWED_GEOMETRY_TYPES = ["Polygon", "MultiPolygon"] as const
export const MAX_FILE_SIZE = 10 * 1024 * 1024 // 10MB in bytes
